import dynamic from 'next/dynamic';

export const assetLibraryComponentsMap = {
  'Hero Half': dynamic(() =>
    import('@portal/shared/components/AssetLibrary/HeroHalf/HeroHalf').then(
      (imports) => imports.HeroHalf
    )
  ),
  'Dietary List': dynamic(() =>
    import('@portal/shared/components/AssetLibrary/DietaryList/DietaryList').then(
      (imports) => imports.DietaryList
    )
  )
} as const;
